import { render, staticRenderFns } from "./FormFlexy.vue?vue&type=template&id=4b20f6d1"
import script from "./FormFlexy.vue?vue&type=script&lang=js"
export * from "./FormFlexy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports